<template>
<div class="ml-4 mb-3">

    <div id="music" class="music">

    </div>
    <p class="my-4" v-if="error">No se encontro el audio</p>
    <button v-if="audio2" class="btn btn-primary ml-3" @click="descagar">Descargar</button>
    <!-- <div style="display: flex;">
        <button  v-if="!play" class="btn btn-primary mr-2" @click="play_m">Play</button>
        <button v-if="play" class="btn btn-primary mr-2" @click="pause_m">{{pause_name}}</button>
        <div class="mr-2" style="display: grid;">
            Tiempo
            <div class="mr-2" v-if="play">{{audionodes[0].currentTime}}</div>
            <div class="mr-2" v-if="play">{{duration}}</div>
        </div>

        <div class="mr-2" style="display: grid;">
            Volumen
            <input type="range" min="1" max="100" v-model="volume" value="50">
        </div>
        <button v-if="audio2" class="btn btn-primary ml-3" @click="descagar">Descargar</button>
        <div v-else>No se encontro audio</div>
    </div> -->

</div>
</template>

<script>
export default {
    props: ['uniqueid'],
    data() {
        return {
            audio1: null,
            audio2: null,
            audionodes: [],
            play: false,
            pause_name: "Pause",
            volume: 50,
            duration: 0,
            current: 0,
            error: false
        };
    },
    mounted() {
        console.log(this.canal);
        if (this.uniqueid) {
            axios({
                    url: '/api/audio/' + this.uniqueid + '/0',
                    method: 'GET',
                    responseType: 'blob', // important
                })
                .then((response) => {
                    this.audio1 = response.data
                    // console.log(t);
                    axios({
                            url: '/api/audio/' + this.uniqueid + '/1',
                            method: 'GET',
                            responseType: 'blob', // important
                        })
                        .then((response2) => {
                            this.audio2 = response2.data
                            this.play_m()
                        })
                        .catch((error) => {
                            console.log(error);
                        });

                })
                .catch((error) => {
                    console.log(error);
                    this.error = true;
                });

        }
    },
    methods: {
        descagar() {
            const url = window.URL.createObjectURL(new Blob([this.audio1]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', this.uniqueid + '1.wav'); //or any other extension
            document.body.appendChild(link);
            link.click();

            const url2 = window.URL.createObjectURL(new Blob([this.audio2]));
            const link2 = document.createElement('a');
            link2.href = url2;
            link2.setAttribute('download', this.uniqueid + '2.wav'); //or any other extension
            document.body.appendChild(link2);
            link2.click();
        },
        resume() {
            const _this = this;
            console.log("SusPEDIO");
            _this.mix.suspend().then(response => {
                console.log("ENTRO");
            })
            // this.audionodes.forEach(function (node, index) {
            //     console.log(_this.milisecond)

            //     node.start(_this.milisecond / 1000);
            // });
        },
        handleFilesSelect() {

            // div.innerHTML = "loading audio tracks.. please wait";
            var files = [this.audio1, this.audio2];
            var chunks = [];
            var channels = [
                [0, 1],
                [1, 0]
            ];
            var _this = this;

            var audio = new AudioContext();
            // _this.player = ;
            var merger = audio.createChannelMerger(2);
            var splitter = audio.createChannelSplitter(2);
            var mixedAudio = audio.createMediaStreamDestination();
            var duration = 60000;
            console.log(this.audio1);
            // console.log(duration);
            var context;
            // var recorder;
            var audioDownload;
            var description = this.uniqueid + '.wav';

            _this.player.controls = "controls";

            function get(file) {
                // description += file.name.replace(/\..*|\s+/g, "");
                console.log(description);
                return new Promise(function (resolve, reject) {
                    var reader = new FileReader;
                    reader.readAsArrayBuffer(file);
                    reader.onload = function () {
                        resolve(reader.result)
                    }
                })
            }

            function stopMix(duration, ...media) {
                setTimeout(function (media) {
                    media.forEach(function (node) {
                        node.stop()
                    })
                }, duration, media)
            }

            Promise.all(files.map(get)).then(function (data) {
                    return Promise.all(data.map(function (buffer, index) {
                            return audio.decodeAudioData(buffer)
                                .then(function (bufferSource) {
                                    var channel = channels[index];
                                    var source = audio.createBufferSource();
                                    source.buffer = bufferSource;
                                    source.connect(splitter);
                                    splitter.connect(merger, channel[0], channel[1]);
                                    return source
                                })
                        }))
                        .then(function (audionodes) {
                            merger.connect(mixedAudio);
                            merger.connect(audio.destination);
                            _this.recorder = new MediaRecorder(mixedAudio.stream);
                            _this.recorder.start(0);
                            _this.audionodes = audionodes;
                            _this.audionodes.forEach(function (node, index) {
                                console.log(node);
                                duration = duration < node.buffer.duration ? node.buffer.duration : duration;
                                console.log("INICIO ", _this.milisecond / 1000);
                                node.start()
                            });
                            _this.interval = setInterval(() => {
                                _this.milisecond++;
                            }, 1);

                            // setTimeout(() => {

                            // }, 5000);
                            duration = duration * 1000
                            duration = 6000
                            // div.innerHTML = "playing and recording tracks..";
                            console.log(duration);
                            stopMix(duration, ..._this.audionodes, _this.recorder);

                            _this.recorder.ondataavailable = function (event) {
                                chunks.push(event.data);
                            };

                            _this.recorder.onstop = function (event) {
                                // console.log("DESCARGA");
                                var blob = new Blob(chunks, {
                                    "type": "audio/ogg; codecs=opus"
                                });
                                audioDownload = URL.createObjectURL(blob);
                                var a = document.createElement("a");
                                let type = blob.type;
                                let indexOF = type.indexOf(";");
                                a.download = description + "." + type.substr(0, indexOF);
                                a.href = audioDownload;
                                a.innerHTML = a.download;
                                _this.player.src = audioDownload;
                                document.body.appendChild(a);
                                document.body.appendChild(_this.player);
                                _this.ready = true;
                                a.click();
                            };
                        })
                })
                .catch(function (e) {
                    console.log(e)
                });
        },
        play_m() {
            const arrayOfAudioBuffers = [this.audio1, this.audio2];
            let _this = this;

            function play(audioBuffer, i) {
                var snd1 = new Audio();
                var src1 = document.createElement("source");
                src1.type = "audio/mpeg";
                src1.src = audioBuffer;
                src1.id = "myAudio" + i;
                snd1.appendChild(src1);
                snd1.volume = 0.5;
                if (i == 0) {
                    snd1.controls = true;
                    document.getElementById('music').appendChild(snd1);
                    // console.log(document.getElementById('music'));
                    snd1.onplay = function () {
                        console.log("ENTRE " + 1);
                        _this.audionodes[1].play();
                    };
                    snd1.onpause = function () {
                        console.log("ENTRE " + 1);
                        _this.audionodes[1].pause();
                    };

                    snd1.onvolumechange = function () {
                        // alert("The volume has been changed!" + e);
                        _this.audionodes[1].volume = snd1.volume;
                    };
                    snd1.ontimeupdate = function () {
                        _this.audionodes[1].currentTime = snd1.currentTime;
                    };
                }

                _this.audionodes.push(snd1);
                // console.log(snd1.duration);
                _this.duration = snd1.duration;
                // snd2.play();
            }
            // _this.recorder = new MediaRecorder(mixedAudio.stream);
            // _this.recorder.start(0);
            for (let i = 0; i < arrayOfAudioBuffers.length; i++) {
                // every time this loops the play function is
                // called around 2 milliseconds after the previous
                // one causing sounds to get slightly out of sync
                play(URL.createObjectURL(arrayOfAudioBuffers[i]), i);
            }
            this.play = true;
        },

        pause_m() {
            if (!this.pause) {
                this.audionodes.forEach(element => {
                    element.pause()
                });
                this.pause_name = "Resume";
            } else {
                this.audionodes.forEach(element => {
                    element.play()
                });
                this.pause_name = "Pause";

            }

            this.pause = !this.pause
        },

    },
    watch: {
        volume() {
            console.log(this.volume / 100);
            this.audionodes.forEach(element => {
                element.volume = this.volume / 100;
            });
        }
    }
};
</script>

<style>
.slidecontainer {
    width: 100%;
}

.slider {
    -webkit-appearance: none;
    width: 100%;
    height: 25px;
    background: #d3d3d3;
    outline: none;
    opacity: 0.7;
    -webkit-transition: .2s;
    transition: opacity .2s;
}

.slider:hover {
    opacity: 1;
}

.slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 25px;
    height: 25px;
    background: #04AA6D;
    cursor: pointer;
}

.slider::-moz-range-thumb {
    width: 25px;
    height: 25px;
    background: #04AA6D;
    cursor: pointer;
}
</style>
